export default defineNuxtPlugin((nuxtApp) => {
  // Vue runtime errors (render/effect errors)
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    const payload = enrichError(error, instance, info);
    // send to your logger or just console
    console.groupCollapsed(
      `🔴 VueError: ${payload.componentName} @ ${payload.route}`
    );
    console.log(payload);
    console.groupEnd();

    // Optional: surface in Nuxt error UI
    // showError({ statusCode: 500, statusMessage: payload.message });
  };

  // Nuxt hook also catches Vue errors, plus unhandled ones
  // nuxtApp.hook("vue:error", (error, instance, info) => {
  //   const payload = enrichError(error, instance, info);
  //   console.warn("nuxtApp.hook(vue:error)", payload);
  // });

  // Unhandled promise rejections in the browser
  window.addEventListener("unhandledrejection", (evt) => {
    console.error("🟠 UnhandledRejection", {
      message: String(evt.reason?.message ?? evt.reason),
      stack: evt.reason?.stack,
      route: useRoute()?.fullPath,
      ua: navigator.userAgent,
      evt,
    });
  });

  // Global script errors
  window.addEventListener("error", (evt) => {
    console.error("🟠 WindowError", {
      message: evt.message,
      filename: evt.filename,
      lineno: evt.lineno,
      colno: evt.colno,
      route: useRoute()?.fullPath,
    });
  });
});

// helper
function enrichError(error: unknown, instance: any, info?: string) {
  const route = tryRoute();
  const comp = tryComponent(instance);
  return {
    message: (error as any)?.message ?? String(error),
    stack: (error as any)?.stack,
    info,
    route,
    ...comp,
    // grab a tiny HTML preview of the vnode element (can help with DOM null issues)
    vnodeEl: instance?.vnode?.el?.outerHTML?.slice(0, 200),
    // you can add app state snippets here if needed
  };
}

function tryRoute() {
  try {
    return useRoute()?.fullPath ?? "(no-route)";
  } catch {
    return "(no-route)";
  }
}

function tryComponent(instance: any) {
  if (!instance) return { componentName: "(no-instance)" };
  const type = instance.type || {};
  return {
    componentName: type.name || "(anonymous)",
    sfcFile: type.__file || "(no-__file)",
    uid: instance.uid,
    props: safeCopy(instance.props),
  };
}

function safeCopy<T>(x: T): T | undefined {
  try {
    return JSON.parse(JSON.stringify(x));
  } catch {
    return undefined;
  }
}
